import { ExternalLink, ShieldCheck } from "lucide-react";
import { openExternalLink } from "@/lib/openExternalLink";

export default function Accreditation() {
  return (
    <section
      id="accreditation"
      className="section bg-[var(--forest-deep)] text-white relative overflow-hidden"
      data-testid="accreditation-section"
    >
      <div className="absolute inset-0 deco-lines opacity-20 pointer-events-none" />
      <div className="container-pl relative">
        <div className="grid md:grid-cols-12 gap-10 md:gap-16 items-center">
          {/* Logo */}
          <div className="md:col-span-5 flex justify-center md:justify-start">
            <div
              className="w-full max-w-md p-8 md:p-10 rounded-2xl bg-black/35 border border-white/10 backdrop-blur-sm"
              data-testid="summit-logo-card"
            >
              <img
                src="/summit-logo.png"
                alt="Te Ara Teitei – Summit Institute"
                className="w-full h-auto"
                loading="lazy"
              />
            </div>
          </div>

          {/* Disclaimer copy */}
          <div className="md:col-span-7" data-testid="accreditation-copy">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/10 border border-white/20 text-[0.72rem] tracking-[0.22em] uppercase font-display font-semibold">
              <ShieldCheck size={14} className="text-[var(--sand-soft)]" />
              NZQA-Accredited Micro-Credential
            </div>

            <h2 className="font-display font-bold text-3xl md:text-5xl mt-5 leading-tight text-white">
              Delivered in partnership with{" "}
              <span className="text-[#7BD389]">Te Ara Teitei — Summit Institute</span>.
            </h2>

            <div className="mt-7 space-y-5 text-white/90 text-base md:text-[1.05rem] leading-relaxed">
              <p>
                This micro-credential is hosted on the{" "}
                <strong className="text-white">
                  New Zealand Qualifications and Credentials Framework
                </strong>{" "}
                through{" "}
                <strong className="text-white">Te Ara Teitei — Summit Institute</strong>{" "}
                (NZQA Provider <span className="font-mono">6659</span>), the accredited education
                organisation that holds the credential with NZQA.
              </p>
              <p>
                Every learner who joins the programme is{" "}
                <strong className="text-[#F6C988]">
                  concurrently enrolled as a student of Summit Institute
                </strong>
                . This concurrent enrolment is what enables you to receive the{" "}
                <strong className="text-white">NZQA-accredited micro-credential</strong>,
                which is recorded on your{" "}
                <strong className="text-white">NZQA Record of Learning</strong>.
              </p>
            </div>

            <div className="mt-8 flex flex-wrap items-center gap-4">
              <a
                href="https://www.nzqa.govt.nz/nzqf/search/microcredentials.do?moe=6659"
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) =>
                  openExternalLink(
                    e,
                    "https://www.nzqa.govt.nz/nzqf/search/microcredentials.do?moe=6659"
                  )
                }
                className="btn btn-sand"
                data-testid="nzqa-listing-link"
              >
                View on NZQA <ExternalLink size={16} />
              </a>
              <div
                className="text-sm text-white/75"
                data-testid="nzqa-listing-reference"
              >
                NZQA Micro-credential Listing{" "}
                <span className="font-display font-semibold text-white">#5684</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
